import classNames from 'classnames';
import { ChevronRight } from 'lucide-react';
import Store from 'assets/img/store/Store.svg';
import { NoAccessBadge } from 'components/common/badges/NoAccessBadge';
import { STORE } from 'state/store/type';

export interface StoreCardProps {
  store: STORE.IStore;
  hasAccess: boolean;
  onClick: (store: STORE.IStore) => void;
  isFirst?: boolean;
  isLast?: boolean;
}

export const StoreCard = ({
  store,
  hasAccess,
  onClick,
  isFirst,
  isLast,
}: StoreCardProps) => {
  const handleClick = () => {
    onClick(store);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className={classNames(
        'h-18 px-4 md:px-5 py-3 md:py-4 bg-white cursor-pointer hover:bg-gray-50 hover:shadow-card-hover',
        'border-x border-b border-gray-blue-20 shadow-card',
        'transition-all duration-200',
        {
          'bg-gray-100 cursor-not-allowed hover:bg-gray-300': !hasAccess,
          'border-t rounded-t-xl': isFirst,
          'rounded-b-xl': isLast,
        }
      )}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      data-testid="storeCard"
      role="button"
      tabIndex={0}
      aria-label={`${store.dba_name}${!hasAccess ? ' (No access)' : ''}`}
    >
      <div className="flex justify-between items-center h-full">
        <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-gray-blue-10 mr-2">
          <img src={Store} alt="" aria-hidden="true" />
        </div>

        <div className="flex-1">
          <div className="flex items-center mb-1">
            <div className="mr-2 text-sm md:text-base font-semibold text-gray-blue-90">
              {store.dba_name}
            </div>
          </div>
        </div>

        <div className="flex justify-center items-center">
          {!hasAccess ? (
            <NoAccessBadge />
          ) : (
            <ChevronRight
              size={20}
              className="text-gray-blue-60"
              aria-hidden="true"
            />
          )}
        </div>
      </div>
    </div>
  );
};
